import * as React from "react";

import {
  createNativeStackNavigator,
  NativeStackScreenProps,
} from "@react-navigation/native-stack";
import Content from "./Content";
import SpecificContent from "./SpecificContent";
export type ContentStackNavParamList = {
  ContentHub: undefined;
  SpecificContent: undefined;
};
const ContentStackNav = createNativeStackNavigator<ContentStackNavParamList>();

const ContentStack = () => {
  return (
    <ContentStackNav.Navigator
      initialRouteName="ContentHub"
      screenOptions={{
        header: (props) => {
          return null;
        },
      }}
    >
      <ContentStackNav.Screen name="ContentHub" component={Content} />
      <ContentStackNav.Screen name="SpecificContent" component={SpecificContent} />
      {/* <DiscountStackNav.Screen name="Specific" component={SpecificCategory} /> */}
    </ContentStackNav.Navigator>
  );
};

export default ContentStack;
